export type PurposeType = {
  purposeId: string;
  label: string;
  description: string;
  version: number;
  organizations: [];
  versionUpdate?: boolean;
};

export enum PurposeStatusType {
  buffer = 1,
  active = 2,
}

export enum TransactionType {
  accept = 'CONFIRMED',
  decline = 'OPT_OUT',
  new = 'NEW_PURPOSE_VERSION',
}

export type ConsentAgreementFormDataType = {
  requestInformation?: string;
  test?: boolean;
  identifier: string;
  purposes: [
    {
      Id: string;
      TransactionType: string;
      Version: number;
    },
  ];
  dsDataElements?: {
    FirstName: string;
    LastName: string;
  };
};

export enum SwitchKeyVault {
  enable = 1,
  disable = 0,
}
